import {axios, API} from '@/api'
import enrollments from './enrollments'

export default {
  async getLanguages() {
    try {
      const response = await axios.get(API.getLanguages(), { headers: enrollments.getAuthHeaders() })
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  },
}
